import { get, post } from './fetch';

/**
 * 用户登录
 * @param {String} email - 用户邮箱
 * @param {String} password - 密码
 * @returns {Promise} - 返回登录请求的Promise
 */
export function login(email, password) {
  return post('/api/user/login', {
    email,
    password
  });
}

/**
 * 用户注册
 * @param {String} email - 用户邮箱
 * @param {String} password - 密码
 * @param {String} name - 用户姓名
 * @returns {Promise} - 返回注册请求的Promise
 */
export function register(email, password, name) {
  return post('/api/user/register', {
    email,
    password,
    name
  });
}

/**
 * 用户登出
 * @returns {Promise} - 返回登出请求的Promise
 */
export function logout() {
  return post('/api/logout');
}

/**
 * 获取token
 * @returns {String} - 返回存储的token
 */
export function getToken() {
  return localStorage.getItem('token');
}

/**
 * 设置token
 * @param {String} token - 要存储的token
 */
export function setToken(token) {
  return localStorage.setItem('token', token);
}

/**
 * 移除token
 */
export function removeToken() {
  return localStorage.removeItem('token');
}

/**
 * 检查是否已登录
 * @returns {Boolean} - 是否已登录
 */
export function isLoggedIn() {
  return !!getToken();
}

/**
 * 获取用户列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码
 * @param {Number} params.size - 每页条数
 * @param {String} params.status - 用户状态（可选）
 * @param {String} params.role - 用户角色（可选）
 * @param {String} params.email - 用户邮箱（可选）
 * @returns {Promise} - 返回请求的Promise
 */
export function getUserList(params) {
  return get('/api/user/list', params);
}

/**
 * 重置用户密码
 */
export function resetUserPassword(params) {
  return get('/api/user/reset-password', params);
}

/**
 * 更新用户审核状态
 * @param {Object} data - 请求数据
 * @param {Number} data.userId - 用户ID
 * @param {Number} data.status - 审核状态：0-待审核，1-审核通过，2-审核未通过
 * @param {Number} data.role - 角色：1-工作人员，2-管理员，3-超级管理员
 * @returns {Promise} - 返回请求的Promise
 */
export function updateUserStatus(data) {
  return post('/api/user/audit', data);
}

/**
 * 检查当前用户是否是超级管理员
 * @returns {Boolean} - 是否是超级管理员
 */
export function isSuperAdmin() {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    return userInfo.role === '3' || userInfo.role === 3;
  } catch (e) {
    console.error('获取用户信息失败', e);
    return false;
  }
}

/**
 * 检查当前用户是否是管理员或超级管理员
 * @returns {Boolean} - 是否是管理员或超级管理员
 */
export function isAdmin() {
  try {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    // 角色为2(管理员)或3(超级管理员)
    return userInfo.role === '2' || userInfo.role === 2 || userInfo.role === '3' || userInfo.role === 3;
  } catch (e) {
    console.error('获取用户信息失败', e);
    return false;
  }
} 